var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1667 11.3789V4.37891H24.5V11.3789H15.1667ZM3.5 16.0456V4.37891H12.8333V16.0456H3.5ZM15.1667 25.3789V13.7122H24.5V25.3789H15.1667ZM3.5 25.3789V18.3789H12.8333V25.3789H3.5ZM5.83333 13.7122H10.5V6.71224H5.83333V13.7122ZM17.5 23.0456H22.1667V16.0456H17.5V23.0456ZM17.5 9.04557H22.1667V6.71224H17.5V9.04557ZM5.83333 23.0456H10.5V20.7122H5.83333V23.0456Z",
    fill: "#367BBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashActive);
export default __webpack_public_path__ + "static/media/dashActive.86f372157fab4c3ea9a612c2c93223da.svg";
export { ForwardRef as ReactComponent };